/* Blindly gift recipient block (snippets/blindly-gift-recipient.liquid).
 *
 * window.BlindlyGiftRecipient.get(rootEl) → instance (mounts on first use):
 *   shipTo()            'them' | 'me'
 *   recipient()         saved address object or null
 *   ensure()            false (and opens the address modal) when 'them' has no address yet
 *   addProps(props)     adds _gift_ship, Gift for, Gift note, From, _gift_recipient_email
 *   addPrefill(params)  adds checkout[shipping_address][...] for a cart permalink ('them' only)
 * Every change dispatches `bgr:change` on the root ({ shipTo, recipient } in detail).
 * Nothing personal is sent to analytics.
 */
(function () {
  if (window.BlindlyGiftRecipient) return;

  var REGIONS = {
    US: [['AL','Alabama'],['AK','Alaska'],['AZ','Arizona'],['AR','Arkansas'],['CA','California'],['CO','Colorado'],['CT','Connecticut'],['DE','Delaware'],['DC','District of Columbia'],['FL','Florida'],['GA','Georgia'],['HI','Hawaii'],['ID','Idaho'],['IL','Illinois'],['IN','Indiana'],['IA','Iowa'],['KS','Kansas'],['KY','Kentucky'],['LA','Louisiana'],['ME','Maine'],['MD','Maryland'],['MA','Massachusetts'],['MI','Michigan'],['MN','Minnesota'],['MS','Mississippi'],['MO','Missouri'],['MT','Montana'],['NE','Nebraska'],['NV','Nevada'],['NH','New Hampshire'],['NJ','New Jersey'],['NM','New Mexico'],['NY','New York'],['NC','North Carolina'],['ND','North Dakota'],['OH','Ohio'],['OK','Oklahoma'],['OR','Oregon'],['PA','Pennsylvania'],['RI','Rhode Island'],['SC','South Carolina'],['SD','South Dakota'],['TN','Tennessee'],['TX','Texas'],['UT','Utah'],['VT','Vermont'],['VA','Virginia'],['WA','Washington'],['WV','West Virginia'],['WI','Wisconsin'],['WY','Wyoming'],['PR','Puerto Rico'],['AA','Armed Forces Americas'],['AE','Armed Forces Europe'],['AP','Armed Forces Pacific']],
    CA: [['AB','Alberta'],['BC','British Columbia'],['MB','Manitoba'],['NB','New Brunswick'],['NL','Newfoundland and Labrador'],['NS','Nova Scotia'],['NT','Northwest Territories'],['NU','Nunavut'],['ON','Ontario'],['PE','Prince Edward Island'],['QC','Quebec'],['SK','Saskatchewan'],['YT','Yukon']]
  };

  function track(event, props) {
    try { if (typeof window.blindlyTrack === 'function') window.blindlyTrack(event, props || {}); } catch (e) {}
  }

  function mount(root) {
    if (root.__bgr) return root.__bgr;
    var modal = root.querySelector('[data-bgr-modal]');
    var form = root.querySelector('[data-bgr-form]');
    var note = root.querySelector('[data-bgr-note]');
    var state = { shipTo: 'them', recip: null };

    function emit() {
      try { root.dispatchEvent(new CustomEvent('bgr:change', { detail: { shipTo: state.shipTo, recipient: state.recip } })); } catch (e) {}
    }
    function fillRegions() {
      var c = form.querySelector('[data-bgr-country]').value;
      var sel = form.querySelector('[data-bgr-prov]');
      var keep = sel.value;
      sel.innerHTML = '<option value="">Select</option>' + REGIONS[c].map(function (r) {
        return '<option value="' + r[0] + '">' + r[1] + '</option>';
      }).join('');
      if (keep) sel.value = keep;
      form.querySelector('[data-bgr-prov-label]').textContent = c === 'CA' ? 'Province' : 'State';
      form.querySelector('[data-bgr-zip-label]').textContent = c === 'CA' ? 'Postal code' : 'ZIP code';
    }
    function open() {
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var first = modal.querySelector('input');
      if (first) setTimeout(function () { first.focus(); }, 50);
      track('gift_recipient_modal_opened');
    }
    function close() {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
    }
    function setShip(to) {
      state.shipTo = to;
      root.querySelectorAll('[data-bgr-ship]').forEach(function (c) {
        var on = c.getAttribute('data-bgr-ship') === to;
        c.classList.toggle('is-selected', on);
        c.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      root.querySelectorAll('[data-bgr-pane]').forEach(function (p) { p.hidden = p.getAttribute('data-bgr-pane') !== to; });
      root.querySelector('[data-bgr-err]').hidden = true;
      track('gift_ship_selected', { ship_to: to });
      emit();
    }
    function save() {
      var fd = new FormData(form);
      var val = function (k) { return (fd.get(k) || '').toString().trim(); };
      var ok = true;
      ['first_name', 'last_name', 'address1', 'city', 'province', 'zip', 'country'].forEach(function (k) {
        var el = form.querySelector('[name="' + k + '"]');
        var bad = !val(k);
        if (el) el.setAttribute('aria-invalid', bad ? 'true' : 'false');
        if (bad) ok = false;
      });
      var em = form.querySelector('[name="email"]');
      if (em && val('email') && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val('email'))) { em.setAttribute('aria-invalid', 'true'); ok = false; }
      if (!ok) { var bad1 = form.querySelector('[aria-invalid="true"]'); if (bad1) bad1.focus(); return; }
      state.recip = {
        first_name: val('first_name'), last_name: val('last_name'),
        address1: val('address1'), address2: val('address2'), city: val('city'),
        province: val('province'), zip: val('zip'), country: val('country'), email: val('email')
      };
      var r = state.recip;
      var row = root.querySelector('[data-bgr-open]');
      row.classList.add('is-set');
      root.querySelector('[data-bgr-addr-icon]').innerHTML = '&#10003;';
      root.querySelector('[data-bgr-addr-title]').textContent = r.first_name + ' ' + r.last_name;
      root.querySelector('[data-bgr-addr-sub]').textContent = [r.address1, r.address2, r.city, r.province, r.zip].filter(Boolean).join(', ');
      root.querySelector('[data-bgr-addr-edit]').hidden = false;
      root.querySelector('[data-bgr-err]').hidden = true;
      close();
      track('gift_recipient_saved', { country: r.country });
      emit();
    }

    fillRegions();
    form.querySelector('[data-bgr-country]').addEventListener('change', fillRegions);
    form.addEventListener('submit', function (e) { e.preventDefault(); save(); });
    if (note) note.addEventListener('input', function () {
      var c = root.querySelector('[data-bgr-note-count]'); if (c) c.textContent = note.value.length;
    });
    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var nt = t.closest('[data-bgr-note-toggle]');
      if (nt) {
        e.stopPropagation();
        var extra = root.querySelector('[data-bgr-extra]');
        if (extra) { extra.hidden = false; nt.hidden = true; nt.setAttribute('aria-expanded', 'true'); var ta = extra.querySelector('textarea'); if (ta) ta.focus(); }
        track('gift_note_opened');
        return;
      }
      if (t.closest('[data-bgr-open]')) { e.stopPropagation(); if (state.shipTo !== 'them') setShip('them'); open(); return; }
      if (t.closest('[data-bgr-close]')) { e.stopPropagation(); close(); return; }
      var card = t.closest('[data-bgr-ship]');
      if (card && !t.closest('[data-bgr-modal]')) {
        e.stopPropagation();
        var to = card.getAttribute('data-bgr-ship');
        if (to !== state.shipTo) setShip(to);
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });

    var api = {
      shipTo: function () { return state.shipTo; },
      recipient: function () { return state.recip; },
      open: open,
      ensure: function () {
        if (state.shipTo === 'them' && !state.recip) {
          root.querySelector('[data-bgr-err]').hidden = false;
          open();
          return false;
        }
        return true;
      },
      addProps: function (props) {
        var r = state.recip;
        var from = (root.querySelector('[data-bgr-from]').value || '').trim();
        var msg = note ? (note.value || '').trim() : '';
        props['_gift'] = '1';
        props['_gift_ship'] = state.shipTo === 'me' ? 'self' : 'recipient';
        if (state.shipTo === 'me') {
          var cardTo = (root.querySelector('[data-bgr-card-to]').value || '').trim();
          if (cardTo) props['Gift for'] = cardTo;
        } else if (r) {
          props['Gift for'] = r.first_name + ' ' + r.last_name;
          if (r.email) props['_gift_recipient_email'] = r.email.toLowerCase();
        }
        if (msg) props['Gift note'] = msg;
        if (from) props['From'] = from;
        return props;
      },
      addPrefill: function (q) {
        var r = state.recip;
        if (state.shipTo !== 'them' || !r) return q;
        var a = 'checkout[shipping_address]';
        q.set(a + '[first_name]', r.first_name);
        q.set(a + '[last_name]', r.last_name);
        q.set(a + '[address1]', r.address1);
        if (r.address2) q.set(a + '[address2]', r.address2);
        q.set(a + '[city]', r.city);
        q.set(a + '[province]', r.province);
        q.set(a + '[country]', r.country);
        q.set(a + '[zip]', r.zip);
        return q;
      }
    };
    root.__bgr = api;
    return api;
  }

  window.BlindlyGiftRecipient = { get: mount };
  function mountAll() { document.querySelectorAll('[data-bgr]').forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountAll); else mountAll();
})();
